<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-skew" style = "background-color: #0066CC">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">About Us
                                </h1>
                                <p class="lead  text-white">D.Y.D. exists to prepare creators for what's next.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-lg" >
            <div class="container">
                <div class="row row-grid justify-content-center" >
                    <div class="col-lg-12 text-center">
                        <h2 class="display-3" >Our Mission
                        </h2>
						<p style="text-color: white">We combine music, artificial intelligence, and blockchain technology to help artists and brands create faster, market smarter, and own more of what they build.

What started as a music platform has evolved into a system for modern creative entrepreneurship. We're building the infrastructure that empowers creators to control their destiny in an increasingly digital world.
							</p>
                        
                    </div>
                </div>
            </div>
        </section>
    <section class="section section-lg section-shaped overflow-hidden my-0">
        <div class="shape shape-default shape-black" style = "background: #0066CC">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container shape-container py-0 pb-5">
            <div class="row row-grid justify-content-between align-items-center">
                <div class="col-lg-6">
                    <h3 class="display-3 text-white">Our Approach
                    </h3>
                    <p class="lead text-white">We partner with creators who are ready to innovate. Using AI-powered tools and blockchain technology, we help artists accelerate their creative process, expand their reach, and retain ownership of their work. Our model is built on collaboration, transparency, and shared growth—because your success is our success.</p>
                </div>
                <div class="col-lg-5 mb-lg-auto">
                    <div class="transform-perspective-right">
                        <card class="border-0" type="secondary" shadow
                              body-classes="px-lg-5 py-lg-5"
                              header-classes="pb-5 bg-white">
                            <template slot="header">
                                <div class="text-muted text-center mb-3">
                                    <small>Follow us on</small>
                                </div>
                                <div class="btn-wrapper text-center">
									<a href="https://www.facebook.com/DYDDoYOURDance/" class="mr-2">
										<base-button type="default" >
											<i class="fa fa-facebook-square mr-2"></i>
											Facebook
										</base-button>
									</a>
									<a href="https://twitter.com/dyddoyourdance">
										<base-button type="default" >
										   <i class="fa fa-twitter mr-2"></i>
											Twitter
										</base-button>
									</a>
                                </div>
                            </template>
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small>Connect with us over email at</small>
									<small>doyourdancedyd@gmail.com</small>
                                </div>
                                <!--<form role="form">
                                    <base-input alternative
                                                type="name"
                                                placeholder="name"
                                                addon-left-icon="ni ni-circle-08">
                                    </base-input>
                                    <base-input alternative
                                                placeholder="Email"
                                                addon-left-icon="ni ni-email-83">
                                    </base-input>
  									<textarea 
									class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Tell us about yourself">														</textarea>

                                    <div class="text-center">
                                        <base-button type="primary" class="my-4">Sign In</base-button>
                                    </div>
                                </form>-->
                            </template>
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
</template>

<script>
export default {
  name: "about",
  components: {}
};
</script>
